"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.text = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const fonts_1 = require("../basic/fonts");
const spaces_1 = require("../basic/spaces");
const media_1 = require("../basic/media");
const colors_1 = require("../basic/colors");
exports.text = (0, basic_1.applyBase)({
    groupHeading: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { borderTop: '1px solid', borderColor: 'black', paddingTop: [1, '13px'] }),
    secondaryHeading: {
        fontSize: fonts_1.fontSizes[3],
        marginBottom: spaces_1.space[2],
        [media_1.media.tablet]: {
            fontSize: fonts_1.fontSizes[4],
        },
    },
    success: {
        color: colors_1.colors.success,
    },
    error: {
        color: colors_1.colors.primary,
    },
    textBlock: (0, basic_1.applyBase)({
        '.text-block': {
            py: ['30px', '75px'],
            mb: [null, 3],
            px: [4, 0],
        },
    }),
    textBlockWrap: (0, basic_1.applyBase)({
        maxWidth: [null, '770px'],
        mx: [null, 'auto'],
    }),
    richText: (0, basic_1.applyBase)({
        p: {
            pb: 3,
        },
        a: {
            color: 'primary',
            display: 'inline',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        ul: {
            pb: 2,
            li: {
                listStyle: 'disc',
                ml: ['20px', '24px'],
            },
        },
        ol: {
            pb: 2,
            li: {
                listStyle: 'decimal',
                ml: ['20px', '23px'],
            },
        },
        h2: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { pb: 3, pt: 3 }),
        h3: Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.S), { pb: 3 }),
        '.text-block-title': font_faces_1.FONT_SIZE.M,
        '.text-block-text': font_faces_1.FONT_SIZE.LARGE,
    }),
});
//# sourceMappingURL=text.js.map